// @flow
import { clearCloudProjectCredentials } from '../../Utils/GDevelopServices/Project';

export const clearCloudProjectCookies = clearCloudProjectCredentials;
